import { CalloutVariant } from 'ui/Callout';
import { Theme, css } from '@emotion/react';

export const calloutRoot = ({ shape, spacing }: Theme) => css`
  border-radius: ${shape?.borderRadius ?? 4}px;
  border-style: solid;
  border-width: 1px;
  padding: ${spacing?.(2) ?? 16}px;
`;

export const calloutDense = ({ spacing }: Theme) => css`
  padding: ${spacing?.(1) ?? 8}px ${spacing?.(1.5) ?? 12}px;
`;

export const calloutVariant = ({ colors }: Theme, variant: CalloutVariant) => {
  if (!colors) {
    return css``;
  }
  switch (variant) {
    case 'default': {
      return css`
        background-color: ${colors.royalLighter};
        border-color: ${colors.royalLight};
      `;
    }

    case 'internal': {
      return css`
        background-color: ${colors.lilacLighter};
        border-color: ${colors.lilacLight};
      `;
    }

    case 'negative': {
      return css`
        background-color: ${colors.watermelonLight};
        border-color: ${colors.watermelonLight};
      `;
    }

    case 'positive': {
      return css`
        background-color: ${colors.appleLighter};
        border-color: ${colors.appleLight};
      `;
    }

    case 'subtle': {
      return css`
        background-color: ${colors.grayLight};
        border-color: ${colors.grayBase};
      `;
    }

    case 'warning': {
      return css`
        background-color: ${colors.sunglowLighter};
        border-color: ${colors.sunglowLight};
      `;
    }
  }
};
